import { render, staticRenderFns } from "./usapppartnersver.vue?vue&type=template&id=9f729718&scoped=true&"
import script from "./usapppartnersver.vue?vue&type=script&lang=js&"
export * from "./usapppartnersver.vue?vue&type=script&lang=js&"
import style0 from "./usapppartnersver.vue?vue&type=style&index=0&id=9f729718&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f729718",
  null
  
)

export default component.exports